import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const LatestTrends = ({ title, posts = [] }) => {
    if (posts.length === 0) {
        return (
            <section className="mt-12">
                <h2 className="text-3xl font-extrabold text-neutral-900 mb-4">{title}</h2>
                <p className="text-xl text-gray-600">No latest trends found.</p>
            </section>
        )
    }

    const mainPost = posts[0]
    const secondaryPosts = posts.slice(1, 4)

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    }

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: 'spring',
                stiffness: 50
            }
        }
    }

    return (
        <section className="mt-12">
            <motion.h2
                className="text-4xl font-extrabold text-neutral-900 mb-8"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                {title}
            </motion.h2>
            <motion.div
                className="grid gap-6 md:grid-cols-12"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.div
                    className="md:col-span-7 lg:col-span-8"
                    variants={itemVariants}
                >
                    <Link to={`/${mainPost.slug.current}`} className="group">
                        <div className="relative aspect-[16/9] overflow-hidden rounded-2xl">
                            <img
                                src={mainPost.mainImage.asset.url}
                                alt={mainPost.title}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70" />
                            <div className="absolute bottom-0 left-0 p-6 text-white">
                                <h3 className="text-2xl md:text-3xl font-bold mb-2 leading-tight">{mainPost.title}</h3>
                                <div className="flex items-center text-sm">
                                    <span className="mr-4">{new Date(mainPost.publishedAt).toLocaleDateString()}</span>
                                    {mainPost.categories && mainPost.categories[0] && (
                                        <span className="px-2 py-1 bg-white/20 rounded-full">{mainPost.categories[0].title}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Link>
                </motion.div>
                <div className="md:col-span-5 lg:col-span-4 space-y-6">
                    {secondaryPosts.map((post, index) => (
                        <motion.div
                            key={post.slug.current}
                            variants={itemVariants}
                            className="group"
                        >
                            <Link to={`/${post.slug.current}`}>
                                <div className="flex items-center space-x-4">
                                    <div className="flex-shrink-0 w-24 h-24 relative overflow-hidden rounded-lg">
                                        <img
                                            src={post.mainImage.asset.url}
                                            alt={post.title}
                                            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                                        />
                                    </div>
                                    <div className="flex-grow">
                                        <h3 className="text-lg font-semibold mb-1 group-hover:text-indigo-600 transition-colors duration-300">{post.title}</h3>
                                        <div className="text-sm text-gray-500">
                                            <span>{new Date(post.publishedAt).toLocaleDateString()}</span>
                                            {post.categories && post.categories[0] && (
                                                <span className="ml-2 px-2 py-1 bg-gray-100 rounded-full">{post.categories[0].title}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </section>
    )
}

export default LatestTrends